import { caption as captionFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * @name caption_node
 */

export const caption = captionFactory({
  parseDOM: [{
    tag: 'figcaption[data-caption]'
  }],
  toDOM() {
    const attrs = {
      'data-caption': 'true'
    };
    return ['figcaption', attrs, 0];
  }
});
export const captionWithLocalId = captionFactory({
  parseDOM: [{
    tag: 'figcaption[data-caption]',
    getAttrs: () => {
      return {
        localId: uuid.generate()
      };
    }
  }],
  toDOM(node) {
    var _node$attrs;
    const attrs = {
      'data-caption': 'true',
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
    };
    return ['figcaption', attrs, 0];
  }
});